import HeaderContent from "../header_content";
import { RequestParamsMakerForHeader } from "@/components/header/scripts/make_request_params_for_header"
import VueStore from "@/store/VueStore";
import axios, { AxiosRequestConfig, AxiosResponse} from "axios";
import { RequestParamsController } from "../../../common/scripts/request_params_controller";
import AuthStoreAPI from "@/services/auth_store_service";
import { AuthStoreType } from "@/types/types";

/**
 * 入力データチェック処理
 * @param self ヘッダーコンテンツ
 */
const validation = (self: HeaderContent) => {
  // ダウンロード対象範囲指定の入力チェック
  if (
    self.downloadCsvForSpreadFromDate === null || self.downloadCsvForSpreadToDate === null
  ) {
    return self.$t("message.enterTargetPeriod");
  }
  // 最後まで進むとチェックOK
  return true;
};

/**
 * ユーザーの認証ストア全件から任意の値のあるストア一件を返す
 * @param self ヘッダーコンテンツ
 */
const authstore = (self: HeaderContent, authStores: AuthStoreType[]) => {
  const authstore_info: AuthStoreType = {
    user_id: null,
    store_name: null,
    accessKey: null,
    secretKey: null,
    region: null
  }
  authStores.forEach((store: AuthStoreType, index: number, array: AuthStoreType[]) => {
    // ユーザーに紐づく認証情報は複数あり得る。任意の、項目が揃ったレコード情報を使う
    if (store.store_name && store.accessKey && store.secretKey && store.region) {
      authstore_info.user_id = store.user_id;
      authstore_info.store_name = store.store_name;
      authstore_info.accessKey = store.accessKey;
      authstore_info.secretKey = store.secretKey;
      authstore_info.region = store.region;
    };
  });
  // 認証情報が一つも得られなかった場合はエラー
  if (authstore_info.user_id === null) {
    alert(self.$t("message.registerACredentialStoreToAccessData"));
  }
  else {
    return authstore_info;
  };
};
/**
 * CSVダウンロード処理
 * @param self ヘッダーコンテンツ
 */
export async function downloadCsvForSpread(self: HeaderContent) {
  try {
    // 入力内容のチェック
    const validationError = validation(self);
    if (typeof validationError === "string") {
      alert(validationError);
      return;
    }
    self.downloadingCsvForSpread = true;
    // リクエスト情報の生成
    const authStores = await AuthStoreAPI.query(VueStore.state.userName);
    const requestBody = RequestParamsMakerForHeader.makeDownloadCsvForSpreadParams(
      self,
      authstore(self, authStores)
    );
    const requestParams: AxiosRequestConfig = RequestParamsController.create_v2(
      "post",
      "customGetCSVSummaryReport",
      requestBody
    );
    // CSVダウンロードAPIの実行
    const apiResponse: AxiosResponse = await axios(requestParams);

    // レスポンスを受けての処理
    if (apiResponse.status === 200) {
      // データ件数を取得
      const count = apiResponse.data.count;
      if (count === 0) {
        alert(self.$t("message.thereIsNoDataWithinTargetPeriod"));
      } else {
        if (count > 100000) {
          alert(self.$t("message.unableToGetAllData") + count.toLocaleString() + self.$t("message.recordsWillBeDownloaded"));
        } else {
          alert(count.toLocaleString() + self.$t("message.recordsWillBeDownloaded"));
        }
        // レスポンスからCSVデータを取得
        const csv = apiResponse.data.csv;
        // データが存在する場合のみダウンロード実行
        const blob = new Blob([csv], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "summary_data.csv";
        link.click();
      }
    } else if (apiResponse.status === 210) {
      alert(self.$t("message.dataSizeExceeds5MBLimitPlsChange"));
    } else {
      alert(self.$t("message.failedToDownload"));
    }
    self.downloadingCsvForSpread = false;
    return;
  } catch (e) {
    console.error(e);
    alert(self.$t("message.failedToDownload"));
    self.downloadingCsvForSpread = false;
    return;
  }
}
